import { useEffect } from "react"

import { type useToast } from "@chakra-ui/react"

interface UseErrorToastProps {
  toast: ReturnType<typeof useToast>
  success: unknown
  successMessage: string
}

const useSuccessToast = ({ toast, success, successMessage }: UseErrorToastProps): void => {
  useEffect(() => {
    if (success) {
      toast({
        title: "Success",
        description: successMessage,
        status: "success",
        duration: 5000,
        isClosable: true
      })
    }
  }, [success, toast, successMessage])
}

export default useSuccessToast
